import NewApplicationPage from "./Template";

const NewOtApplicationPage = () => <NewApplicationPage type="OT" />;

export default NewOtApplicationPage;
